import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import InputLabel from "@mui/material/InputLabel";
import { MenuItem, Select, TextField } from "@mui/material";
import {
  addPaymentMethod,
  deletePaymentMethod,
  editPaymentMthod,
  getCurrency,
  getPaymentMethod,
  getPaymentMethodById,
} from "../../../service/api";
import { toast } from "react-toastify";
import { Spinner, Toast } from "react-bootstrap";
import { FaArrowLeft, FaPlus } from "react-icons/fa";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import { sanitizeInput } from "../../../config/validation";
import moment from "moment";
import { triggerDownload } from "../../../config/downloadUtils";

const formatDate = (val) => (val ? moment(val).format("DD/MM/YYYY") : "-");

const ALL_COLUMNS = [
  {
    key: "currency",
    title: "Currency",
    defaultVisible: true,
    render: (r) => r?.currency?.name || "-",
  },
  {
    key: "type",
    title: "Method Type",
    defaultVisible: true,
    render: (r) => r?.type || "-",
  },
  {
    key: "isP2PSupport",
    title: "P2P Enabled",
    defaultVisible: false,
    render: (r) => (r?.isP2PSupport ? "Yes" : "No"),
  },
  {
    key: "isBuySell",
    title: "Buy/Sell",
    defaultVisible: false,
    render: (r) => (r?.isBuySell ? "Yes" : "No"),
  },
  {
    key: "createdAt",
    title: "Date",
    defaultVisible: true,
    render: (r) => formatDate(r?.createdAt),
  },
];


const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  background: "white",
  // border: '1px solid #000',
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

const Payment = () => {
  const [roleInput, setroleInput] = useState({
    type: "",
    currency: "",
    isBuySell: "",
    isP2PSupport: "",
    fields: [],
  });
  console.log("%c Line:43 🍏 roleInput", "color:#2eafb0", roleInput);
  const [roleInputError, setroleInputError] = useState({
    isBuySell: false,
    isP2PSupport: false,
    type: false,
    currency: false,
    fields: false,
  });
  const [currencyList, setCurrencyList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [user, setUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const [id, setId] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [pair, setPair] = useState({
    type: "",
    typeErr: false,
    name: "",
    nameErr: false,
  });

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "payment-list",
    allColumns: ALL_COLUMNS,
  });

  const roleChange = (e) => {
    const { name, value } = e.target;
    setroleInput({ ...roleInput, [name]: sanitizeInput(value) });
    setroleInputError({ ...roleInputError, [name]: false });
  };

  const getCurrencyList = () => {
    let body = {
      page: page,
      sizePerPage: 10,
      pagination: false,
    };

    setLoading(true);
    getCurrency(body)
      .then((res) => {
        if (res?.status) {
          setCurrencyList(res?.data?.result);
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const getPairList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
    };
    if (searchTerm) {
      body.search = searchTerm;
    }

    setLoading(true);
    getPaymentMethod(body)
      .then((res) => {
        if (res?.status) {
          setPaymentMethodList(res?.data);
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const body = { pagination: false };
    if (searchTerm) body.search = searchTerm;
    setDownloadLoading(true);
    getPaymentMethod(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "payment-methods");
      })
      .finally(() => setDownloadLoading(false));
  };

  const handleClear = () => {
    setroleInput({
      ...roleInput,
      type: "",
      currency: "",
      isBuySell: "",
      isP2PSupport: "",
      fields: [],
    });
    setroleInputError({
      isBuySell: false,
      isP2PSupport: false,
      type: false,
      currency: false,
      fields: false,
    });
  };
  // ADD USER FUNCTION
  const addUserFun = () => {
    let newErrors = { ...roleInputError };

    if (!roleInput?.currency) {
      newErrors.currency = true;
      toast.error("Please Select currency", { toastId: 'payment-validation-error' });
    }

    if (
      roleInput?.isP2PSupport === undefined ||
      roleInput?.isP2PSupport === null ||
      typeof roleInput?.isP2PSupport !== "boolean"
    ) {
      newErrors.isP2PSupport = true;
      toast.error("Please Select P2P Enable", { toastId: 'payment-validation-error' });
    }

    if (
      roleInput?.isBuySell === undefined ||
      roleInput?.isBuySell === null ||
      typeof roleInput?.isBuySell !== "boolean"
    ) {
      newErrors.isBuySell = true;
      toast.error("Please Select Buy/Sell Option", { toastId: 'payment-validation-error' });
    }
    if (!roleInput?.fields || roleInput?.fields?.length === 0) {
      newErrors.fields = true;
      toast.error("Please add Option", { toastId: 'payment-validation-error' });
    }

    setroleInputError(newErrors);

    const hasError = Object.values(newErrors).some((error) => error === true);
    console.log("%c Line:169 🌽 hasError", "color:#ed9ec7", hasError);

    if (!hasError) {
      setLoading(true);
      if (!edit) {
        const object = roleInput?.fields?.reduce((acc, curr) => {
          const key = Object.keys(curr)[0];
          return { ...acc, [key]: curr[key] };
        }, {});
        let body = {
          type: roleInput.type,
          currency: roleInput.currency,
          isP2PSupport: roleInput.isP2PSupport,
          isBuySell: roleInput.isBuySell,
          fields: object,
        };

        addPaymentMethod(body)
          .then((res) => {
            if (res?.status) {
              toast.success(res?.message, { toastId: 'payment-add-success' });
              setUser(false);
              getPairList();
              handleClear();
            } else {
              toast.error(res?.message, { toastId: 'payment-add-error' });
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message, { toastId: 'payment-add-error' });
          })
          .finally((res) => {
            setLoading(false);
          });
      } else {
        const object = roleInput?.fields?.reduce((acc, curr) => {
          const key = Object.keys(curr)[0];
          return { ...acc, [key]: curr[key] };
        }, {});
        let body = {
          isP2PSupport: roleInput.isP2PSupport,
          isBuySell: roleInput.isBuySell,
          // type: roleInput.type,
          fields: object,
        };

        editPaymentMthod(id?._id, body)
          .then((res) => {
            if (res?.status) {
              toast.success(res?.message, { toastId: 'payment-update-success' });
              setEdit(false);
              setUser(false);
              getPairList();
              handleClear();
            } else {
              toast.error(res?.message, { toastId: 'payment-update-error' });
            }
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message, { toastId: 'payment-update-error' });
          })
          .finally((res) => {
            setLoading(false);
          });
      }
    }
  };
  // DELETE USER FUNCTION

  const handleDeleteFunction = () => {
    setLoading(true);
    deletePaymentMethod(id?._id)
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message, { toastId: 'payment-delete-success' });
          handleCloseDelete();
          getPairList();
          setId(null);
        } else {
          toast.error(res?.message, { toastId: 'payment-delete-error' });
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message, { toastId: 'payment-delete-error' });
      })
      .finally((res) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getCurrencyList();
  }, []);

  useEffect(() => {
    getPairList();
  }, [page, pageSize, searchTerm]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, searchTerm]);

  const getPaymentMethodDataById = (id) => {
    getPaymentMethodById(id)
      ?.then((res) => {
        if (res?.status) {
          let data = res?.data;
          const array = Object.entries(data?.fields).map(([key, value]) => ({
            [key]: value,
          }));
          setroleInput({
            ...roleInput,
            type: data?.type,
            currency: data?.currency?._id,
            isBuySell: data?.isBuySell,
            isP2PSupport: data?.isP2PSupport,
            fields: array,
          });
        }
      })
      .catch((e) => {});
  };

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end">
        <a
          className="me-1 btn btn-sm bg-success-light "
          onClick={() => {
            setId(row);

            handleClear();
            setUser(true);
            setEdit(true);
            getPaymentMethodDataById(row?._id);
          }}
        >
          <i className="fe fe-pencil"></i> Edit
        </a>

        <a
          onClick={() => {
            handleOpenDelete(), setId(row);
          }}
          className="me-1 btn btn-sm bg-danger-light"
        >
          <i className="fe fe-trash"></i> Delete
        </a>
      </div>
    ),
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-aut0">
                <h3 className="page-title">Payment method</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Payment method</li>
                </ul>
              </div>
              {!user && (
                <div className="col-sm-5 col">
                  <a
                    onClick={() => {
                      handleClear(), setEdit(false), setUser(true);
                    }}
                    data-bs-toggle="modal"
                    className="btn btn-primary float-end mt-2"
                  >
                    Add Payment Method
                  </a>
                </div>
              )}
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              {user ? (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0px",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <FaArrowLeft
                        style={{
                          marginTop: "3px",
                          cursor: "pointer",
                          width: "30px",
                          height: "20px",
                        }}
                        onClick={() => {
                          setEdit(false), setUser(false);
                        }}
                      />
                      <h4>
                        {edit ? "Edit Payment Method" : "Add Payment Method"}
                      </h4>
                    </div>{" "}
                    <div
                      style={{
                        // borderTop: "1px solid grey",
                        height: "56px",
                        display: "flex",
                        justifyContent: "end",
                        // marginTop: "30px",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={addUserFun}
                        disabled={loading}
                        style={{ marginBottom: "10px", marginTop: "9px" }}
                      >
                        {loading ? (
                          <Spinner size="sm" />
                        ) : edit ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </button>
                    </div>
                  </div>
                  <div style={{ margin: "10px" }} className="page-grid">
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Transfer Type &nbsp;
                        {roleInputError?.type && (
                          <small style={{ color: "red" }}>
                            {"Transfer Type is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "5px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="Name"
                        value={roleInput?.type}
                        onChange={roleChange}
                        name="type"
                        id="type"
                      />
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Currency List &nbsp;
                        {roleInputError?.currency && (
                          <small style={{ color: "red" }}>
                            {"Currency List is required"}
                          </small>
                        )}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="form-control"
                        value={roleInput?.currency}
                        onChange={roleChange}
                        disabled={edit}
                        name="currency"
                        style={{
                          border: "none",
                          padding: 0,
                          height: "56px",
                        }}
                      >
                        {currencyList &&
                          currencyList?.length > 0 &&
                          currencyList?.map((item, _id) => {
                            return (
                              <MenuItem
                                key={_id}
                                style={{ height: "50px" }}
                                value={item?._id}
                              >
                                {item?.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </div>
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        P2P Enable &nbsp;
                        {roleInputError?.isP2PSupport && (
                          <small style={{ color: "red" }}>
                            {"P2P is required"}
                          </small>
                        )}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="form-control"
                        value={roleInput?.isP2PSupport}
                        onChange={roleChange}
                        name="isP2PSupport"
                        style={{
                          border: "none",
                          padding: 0,
                          height: "56px",
                        }}
                      >
                        <MenuItem style={{ height: "50px" }} value={true}>
                          Yes
                        </MenuItem>
                        <MenuItem style={{ height: "50px" }} value={false}>
                          No
                        </MenuItem>
                      </Select>
                    </div>{" "}
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Buy/Sell &nbsp;
                        {roleInputError?.isBuySell && (
                          <small style={{ color: "red" }}>
                            {"Buy/Sell is required"}
                          </small>
                        )}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="form-control"
                        value={roleInput?.isBuySell}
                        onChange={roleChange}
                        name="isBuySell"
                        style={{
                          border: "none",
                          padding: 0,
                          height: "56px",
                          marginLeft: "7px",
                        }}
                      >
                        <MenuItem style={{ height: "50px" }} value={true}>
                          Yes
                        </MenuItem>
                        <MenuItem style={{ height: "50px" }} value={false}>
                          No
                        </MenuItem>
                      </Select>
                    </div>
                  </div>
                  <div style={{ margin: "10px" }} className="page-grid">
                    <div>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ marginLeft: "7px" }}
                      >
                        Name&nbsp;
                        {pair?.nameErr && (
                          <small style={{ color: "red" }}>
                            {"Name is required"}
                          </small>
                        )}
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        style={{
                          // width: "370px",
                          marginLeft: "0px",
                          height: "100%",
                        }}
                        className="form-control"
                        type="text"
                        placeholder="Name"
                        value={pair?.name}
                        onChange={(e) =>
                          setPair({
                            ...pair,
                            name: sanitizeInput(e.target.value),
                            nameErr: false,
                          })
                        }
                        name="name"
                        id="name"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        width: "100%",
                      }}
                    >
                      <div>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ marginLeft: "7px" }}
                        >
                          Type &nbsp;
                          {pair?.typeErr && (
                            <small style={{ color: "red" }}>
                              {"Type is required"}
                            </small>
                          )}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="form-control"
                          value={pair?.type}
                          onChange={(e) =>
                            setPair({
                              ...pair,
                              type: e.target.value,
                              typeErr: false,
                            })
                          }
                          name="name"
                          style={{
                            border: "none",
                            padding: 0,
                            height: "56px",
                            width: "344px",
                          }}
                        >
                          <MenuItem style={{ height: "50px" }} value={"text"}>
                            Text
                          </MenuItem>
                          <MenuItem style={{ height: "50px" }} value={"number"}>
                            Number
                          </MenuItem>
                          <MenuItem style={{ height: "50px" }} value={"file"}>
                            File
                          </MenuItem>
                        </Select>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "8px",
                          border: "2px solid grey",
                          height: "56px",
                          width: "56px",
                          cursor: "pointer",
                          marginTop: "20px",
                        }}
                        onClick={() => {
                          if (!pair?.type && !pair?.name) {
                            setPair({
                              ...pair,
                              typeErr: true,
                              nameErr: true,
                            });
                            return;
                          } else if (!pair?.name) {
                            setPair({
                              ...pair,

                              nameErr: true,
                            });
                            return;
                          } else if (!pair?.type) {
                            setPair({
                              ...pair,
                              typeErr: true,
                            });
                            return;
                          } else {
                            setroleInput({
                              ...roleInput,
                              fields: [
                                ...roleInput?.fields,
                                { [pair.name]: pair.type },
                              ],
                            });
                            setPair({
                              type: "",
                              typeErr: false,
                              name: "",
                              nameErr: false,
                            });
                          }
                        }}
                      >
                        <FaPlus />
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBlock: "20px" }}>
                    {roleInput?.fields && roleInput?.fields?.length > 0 && (
                      <table
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              Name&type
                            </th>

                            <th
                              style={{
                                border: "1px solid black",
                                padding: "8px",
                              }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {roleInput?.fields?.map((p, index) => {
                            return (
                              <tr key={index}>
                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                  }}
                                >
                                  {Object.entries(p).map(([key, value]) => (
                                    <div key={key}>
                                      <strong>{key}</strong>: {value}
                                    </div>
                                  ))}
                                </td>

                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  <button
                                    onClick={() => {
                                      const updatedPairs =
                                        roleInput?.fields?.filter(
                                          (_, i) => i !== index
                                        );
                                      setroleInput({
                                        ...roleInput,
                                        fields: updatedPairs,
                                      });
                                    }}
                                    style={{
                                      backgroundColor: "red",
                                      color: "white",
                                      border: "none",
                                      padding: "5px 10px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              ) : (
                <div className="list-layout">
                  <div className="list-layout__main">
                    <div className="card">
                      <div className="card-body">
                        <TableToolbar
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pageSizeOptions={pageSizeOptions}
                          total={paymentMethodList?.total}
                          page={page}
                          visibleColumnKeys={visibleColumnKeys}
                          allColumns={ALL_COLUMNS}
                          toggleColumn={toggleColumn}
                          resetColumns={resetColumns}
                          onDownload={handleDownload}
                          downloadLoading={downloadLoading}
                        />
                        <div className="table-responsive">
                          {loading ? (
                            <div className="his-spin">
                              <Spin
                                size="large"
                                style={{ position: "relative", top: "35%" }}
                              />
                            </div>
                          ) : (
                            <Table
                              pagination={false}
                              style={{ overflowX: "auto" }}
                              columns={columns2}
                              dataSource={
                                paymentMethodList
                                  ? paymentMethodList?.result
                                  : []
                              }
                              rowKey={(record) => record._id || record.id}
                            />
                          )}
                          {paymentMethodList &&
                            paymentMethodList?.total > pageSize && (
                              <CustomPagination
                                key={`pg-${pageSize}`}
                                totalTabs={paymentMethodList?.total}
                                tabsPerPage={pageSize}
                                handleChange={setPage}
                                className={`${
                                  loading ? "display-hide" : "display-flex"
                                }`}
                              />
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="list-layout__filters">
                    <FilterPanel
                      count={paymentMethodList?.total}
                      onClear={() => {
                        setSearchTerm("");
                      }}
                    >
                      <FilterPanel.Field label="Search">
                        <input
                          type="text"
                          placeholder="Method type"
                          value={searchTerm}
                          onChange={(e) =>
                            setSearchTerm(sanitizeInput(e.target.value))
                          }
                        />
                      </FilterPanel.Field>
                    </FilterPanel>
                  </div>
                </div>
              )}
            </div>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "10px", textAlign: "center" }}>
                  Please confirm before deleting
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={handleDeleteFunction}
                    style={{ marginBottom: "10px", marginTop: "15px" }}
                  >
                    {loading ? <Spinner size="sm" /> : "Delete"}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleCloseDelete}
                    style={{
                      marginLeft: "7px",
                      marginBottom: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Payment;
